import React, {Component} from 'react';
import serialize from 'form-serialize';
import { withRouter } from "react-router-dom";
import {connect} from 'remx'
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment'

import broker from "../utils/broker"
import authStore from "../stores/auth"
import dataStore from "../stores/data"
import SweetAlert from 'react-bootstrap-sweetalert';

class StandardCRUD extends Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 3,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.state = {
        loading: false,
        body_data_table : {search: '', start:0, length: 0},
        data_table: [],
        page_index:1,
        data_meta: {current_page: 0, from : 0, last_page: 0, per_page: 0, total: 0, to : 0},
        data_per:null,
        url: this.props.url,
        url_parrent : this.props.url_parrent,
        custom_button : this.props.custom_button,
        id_pk: this.props.id_pk,
        style_form : this.props.style_form,
        style_container : this.props.style_container,
        search_query:this.props.search_query,
        add_form: this.props.add_form,
        columns_number: [{ header: 'No', id: 'number_counter', accessor: 'number_counter'}],
        columns_hidden_id:
            {   header: 'Option', id : 'option_id', accessor: this.props.id_pk_column, show: false},
        columns_option:
            {   header: 'Option', id : 'option_column', accessor: 'option_column'},
        errors: {},
        columns: this.props.columns,
        table_id_clicked : null,
        modal_delete: false,
    }
        this.getDataTable = this.getDataTable.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }
    notify_berhasil = (text) => toast("Data " + this.props.title + " Berhasil " + text);
    getDataTable() {
        this.setState({ loading: true });
        var custom_query = (this.props.custom_query) ? this.props.custom_query + '&' : '';
        broker.fetch.get(`${this.state.url.url_get_data}?q=${this.state.search_query}&${custom_query}page=${this.state.page_index}`).then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({loading: false, 
                               data_table: data.data, 
                               data_meta: {
                                   current_page: data.current_page,
                                   from : data.from,
                                   to : data.to,
                                   last_page : data.last_page,
                                   per_page : data.per_page,
                                   total : data.total,
                               }})
            } else {
                
            }
        }).catch(err => {
            this.setState({
                loading: false,
                message: ''
            })
        }).then(()=> {
            dataStore.setters.setReloadTable(false);
        });
    }


    componentDidMount() {
        this.setState({body_data_table : {search: '', start:0, length: this.state.page_size}}, function(){
            this.getDataTable();
        })
        if (this.props.column_option !== false) {
            this.setState({columns: this.state.columns_number.concat(this.state.columns.concat(this.state.columns_option)) })
        } else {
            this.setState({columns: this.state.columns_number.concat(this.state.columns) })
        }
       
    }

    getDataPaging(type){
        var page = 0;
        if (type === 'prev'){
            page = this.state.page_index - 1
        } else {
            page = this.state.page_index + 1
        }
        this.setState({page_index: page}, function(){
            this.getDataTable();
        })
        
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.reload_table !== prevProps.reload_table){
            if (this.props.reload_table === true) {
                this.getDataTable();
                this.notify_berhasil("Diupdate");
                
            }
        }
        if(this.props.custom_query !== prevProps.custom_query){
           this.getDataTable();
        }

        if (this.state.search_query !== prevState.search_query){
            this.getDataTable();
        }
    }

    rowClick(id){
        this.setState({table_id_clicked : id});
        broker.fetch.get(`${this.props.url.url_get_data_per}/${id}`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                dataStore.setters.setDataPer(data.data);
            } else {

            }
        }).catch(err => {
            
        });
    }

    handleSearch(event){
        this.setState({search_query: event.target.value});
    }

    render() {
        return (
            <div className={this.state.style_container}>
                <div>
                    <div>
                        <div className="d-sm-flex align-items-center justify-content-between mg-b-20">
                            <div>
                                <h4 className="mg-b-0 tx-spacing--1">{this.props.title}</h4>
                            </div>
                            
                                <div className="d-none d-md-block">
                                    {/* {(this.state.url_parrent) &&
                                            <button className="btn btn-sm pd-x-15 btn-warning btn-uppercase mg-l-5" 
                                            onClick={() => this.props.history.push(this.state.url_parrent)}>
                                            <i className="fa fa-undo"></i> Back To
                                        </button>
                                    } */}
                                    {(this.state.custom_button) &&
                                            <button className={this.state.custom_button.style} 
                                            onClick={() => this.props.history.push(this.state.custom_button.url)}>
                                            <i className={this.state.custom_button.icon}></i> {this.state.custom_button.text}
                                        </button>
                                    }
                                </div>
                        </div>
                        <div>
                            <div className="df-example" data-label={this.props.title}>
                                {(this.props.search_column) &&
                                    <div className="float-right">
                                        <div className="input-group mg-b-10">
                                            <input type="text" className="form-control input-line-style" onChange={this.handleSearch} placeholder="Search......." />
                                        </div>
                                    </div>
                                }
                                <div className="table-responsive">
                                    <table className="table mg-b-0">
                                        <thead>
                                            <tr>
                                                {
                                                    this.state.columns.map((column, i) => {   
                                                        return <th key={i}>{column.header}</th>
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.data_table.map((data, j) => {   
                                                    return  <tr key={j} onClick={() => this.rowClick(data.id)} className={(this.state.table_id_clicked === data.id) ? 'tr-pointer tr-active' : 'tr-pointer'}>
                                                                {
                                                                    this.state.columns.map((column, i) => {   
                                                                        return <td key={i}>
                                                                                    {(!column.Cell) && (column.id !== 'option_column') && (column.id !== 'number_counter') && (column.child_accessor) &&
                                                                                        data[column.accessor][column.child_accessor]
                                                                                    }
                                                                                    {(!column.Cell) && (column.id !== 'option_column') && (column.id !== 'number_counter') && (!column.child_accessor) &&
                                                                                        data[column.accessor]
                                                                                    }
                                                                                    {(!column.Cell) && (column.id === 'option_column') &&
                                                                                        <div className="d-none d-md-block">
                                                                                            <button className="btn btn-xs pd-x-10 btn-outline-dark btn-uppercase mg-l-5" onClick={() => this.getDataPer(data.id)}><i className="fa fa-pencil-alt"></i></button>
                                                                                            <button className="btn btn-xs pd-x-10 btn-outline-dark btn-uppercase mg-l-5" onClick={() => this.setState({modal_delete:true, id_delete_edit: data.id})}><i className="fa fa-trash"></i></button>
                                                                                        </div>
                                                                                    }
                                                                                    {(!column.Cell) && (column.id === 'number_counter') &&
                                                                                        (j+this.state.data_meta.from) +`.`      
                                                                                    }
                                                                                    {(column.Cell) &&
                                                                                        column.Cell({value : data[column.accessor], row : data})
                                                                                    }
                                                                                    
                                                                                </td>
                                                                    })
                                                                }
                                                            </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-sm-flex align-items-center justify-content-between mg-t-20-f">
                                    <div>
                                        <p>Showing {this.state.data_meta.from} to {this.state.data_meta.to}  of {this.state.data_meta.total} entries
                                        </p>
                                    </div>
                                    <div className="d-none d-md-block">
                                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" 
                                                disabled={(this.state.data_meta.current_page === 1) ? true : false} 
                                                onClick={() => this.getDataPaging("prev")}><i className="fa fa-chevron-left"></i> Prev
                                        </button>
                                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" 
                                                disabled={this.state.data_meta.current_page === this.state.data_meta.last_page ? true : false}
                                                onClick={() => this.getDataPaging("next")}>Next <i className="fa fa-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <SweetAlert
                    show={this.state.modal_delete}
                    warning
                    showCancel
                    confirmBtnText="Yes, delete it!"
                    confirmBtnBsStyle="danger"
                    title="Are you sure?"
                    closeOnClickOutside= {false}
                    onConfirm={() => { this.deleteData()}}
                    onCancel={() => this.setState({ modal_delete: false })}
                />
                <ToastContainer 
                    position='bottom-right'
                />
            </div>
        );
    }
}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        reload_table: dataStore.getters.getReloadTable(),     
    }
}

export default withRouter(connect(mapStateToProps)(StandardCRUD));
